import React from 'react';
import { connect } from 'react-redux';
import { Button, Grid, Typography } from '@material-ui/core';
import { ImageSection } from 'app/components/ImageSection';
import { useTranslation } from 'react-i18next';
import { RootState } from 'app/store/types';
import { DocumentUploadButton } from 'app/components/DocumentUploadButton';
import { getLinksByForm } from '../../reducers/app-config';
import { OpenInNew } from '@material-ui/icons';
import { DownloadChecklist } from '../DownloadChecklist';
import { routes } from 'app/routes/route-list';

type MappedProps = ReturnType<typeof mapStateToProps>;
type Props = MappedProps

const UploadDocumentsComponent = (props: Props) => {
  const { t } = useTranslation();
  const { canShowChecklist, confirmationImage, links } = props;
  return (
    <Grid container={false}>
      <Grid item classes={{ item: 'noStepper' }}>
        <ImageSection image={confirmationImage}>
          <Typography variant='h6' classes={{ h6: 'titleMargin section' }}>
            {t('turbo.uploadDocuments.title', { defaultValue: 'Please upload the following documents:' })}
          </Typography>
          <Typography variant='body2' paragraph={true}>
            {t('turbo.uploadDocuments.paragraph1', {
              defaultValue:
                <ul>
                  <li>Copy of Drivers License</li>
                  <li>Current Mortgage Statement</li>
                  <li>Home Insurance Declaration Page</li>
                  <li>HOA Invoice (if applicable)</li>
                </ul>,
            })}
          </Typography>
          <Grid container justifyContent='flex-start' style={{ padding: '20px 0px' }}>
            {canShowChecklist && (<><Grid item xs={12}>
              <DocumentUploadButton />
            </Grid><Grid item xs={12}>
              <DownloadChecklist />
            </Grid></>)}
            {
              links.map(({ title, url }, index) => <Grid key={index} item xs={12}>
                <Button
                  classes = { { root: 'longButton' } }
                  color   = 'primary'
                  variant = 'contained'
                  rel     = 'noopener'
                  target  = '_blank'
                  href    = { url }
                  endIcon = {<OpenInNew />}
                >
                  { title }
                </Button>
              </Grid>,
              )
            }
          </Grid>
        </ImageSection>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = (state: RootState) => ({
  confirmationImage : state.config.confirmationImage,
  links             : getLinksByForm(state),
  canShowChecklist  : (
    state.router.location.pathname === routes.homeEquityTurbo || 
    state.router.location.pathname === routes.homeEquityTurboWelcome
  ),
});

export const UploadDocumentsStep = connect(mapStateToProps)(UploadDocumentsComponent);
